<template>
  <div>
    <view-table
        ref="viewTable"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="sd/so/ma/page"
        @reset="resetHandle"
        @select="selectHandle">
      <template slot="otherBtn">
        <el-button v-if="deliveryAuth"
                   type="primary"
                   style="margin-left: 10px"
                   :loading="submitLoading"
                   :disabled="!selection.length"
                   @click="createDelivery">
          创建发货通知单
        </el-button>
      </template>
      <template slot="adSearch">
        <div class="vm-search">
          <el-form :inline="true" :model="filter" label-width="65px" @keyup.enter.native="loadData(1)">
            <el-form-item label="订单编号">
              <el-input v-model.trim="filter.salesOrderNo" placeholder="请输入" clearable/>
            </el-form-item>
            <el-form-item label="交货日期">
              <el-date-picker
                  v-model="deliveryDateRange"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  value-format="yyyy-MM-dd"
                  @change="deliveryDateRangeChange"/>
            </el-form-item>
            <el-form-item label="物料类型">
              <el-select v-model="filter.materialTypeId" placeholder="请选择" clearable>
                <el-option
                    v-for="item in materialTypeList"
                    :key="item.pkid"
                    :label="item.materialTypeName"
                    :value="item.pkid"/>
              </el-select>
            </el-form-item>
            <el-form-item label="订单状态">
              <el-select v-model.trim="filter.statusName" clearable placeholder="请选择">
                <el-option label="草稿" value="草稿"/>
                <el-option label="业务经理审核" value="业务经理审核"/>
                <el-option label="总经理审核" value="总经理审核"/>
                <!--                <el-option label="作废" :value="999"/>-->
                <el-option label="计划交期确认" value="计划交期确认"/>
                <el-option label="通过" value="通过"/>
                <el-option label="退回" value="退回"/>
              </el-select>
            </el-form-item>
            <el-form-item label="客户名称">
              <el-input v-model.trim="filter.customer" placeholder="请输入" clearable/>
            </el-form-item>
            <el-form-item label="订单类型">
              <el-select v-model.trim="filter.salesOrderCategory" clearable placeholder="请选择">
                <el-option label="销售订单" :value="10"/>
                <el-option label="赠送订单" :value="20"/>
                <el-option label="借用订单" :value="30"/>
                <el-option label="样品订单" :value="40"/>
              </el-select>
            </el-form-item>
            <el-form-item label="ERP编号">
              <el-input v-model.trim="filter.erpSalesOrderNo" placeholder="请输入" clearable/>
            </el-form-item>
            <el-form-item label="合同号">
              <el-input v-model.trim="filter.customerContractNo" placeholder="请输入" clearable/>
            </el-form-item>
            <el-form-item label="项目名称">
              <el-input v-model.trim="filter.projectName" placeholder="请输入" clearable/>
            </el-form-item>
            <el-form-item label="物料编号">
              <el-input v-model.trim="filter.materialNo" placeholder="请输入" clearable/>
            </el-form-item>
            <el-form-item label="物料名称">
              <el-input v-model.trim="filter.materialName" placeholder="请输入" clearable/>
            </el-form-item>
            <el-form-item label="规格型号">
              <el-input v-model.trim="filter.specification" placeholder="请输入" clearable/>
            </el-form-item>
            <el-form-item label="备注">
              <el-input v-model.trim="filter.detailNote" placeholder="请输入" clearable/>
            </el-form-item>
          </el-form>
        </div>
      </template>
    </view-table>
    <!--    <sales-order-edit ref="salesOrderEdit" :options="options" @save-success="loadData"/>-->
    <delivery-notice-edit ref="deliveryNoticeEdit" :options="options" @save-success="loadData"/>
  </div>
</template>

<script>
  import ViewTable from "@/components/ViewTable";
  import DeliveryNoticeEdit from "@/views/SalesManage/DeliveryNotice/DeliveryNoticeEdit";

  export default {
    name: "SalesOrderDetailUnDeliveryList",
    components: {ViewTable, DeliveryNoticeEdit},
    data() {
      return {
        deliveryAuth: this.$auth(293),
        submitDateRange: [],
        deliveryDateRange: [],
        materialTypeList: [],
        filter: {
          salesOrderNo: "",
          deliveryBeginDate: "",
          deliveryEndDate: "",
          materialTypeId: "",
          statusName: "",
          customer: "",
          salesOrderCategory: "",
          erpSalesOrderNo: "",
          customerContractNo: "",
          projectName: "",
          materialNo: "",
          materialName: "",
          specification: "",
          detailNote: "",
        },
        columnsProperty: [
          {
            key: "salesOrderNo",
            width: 130,
            align: "center",
            render: (h, params) => {
              return h(
                  "span",
                  {
                    style: {
                      color: "#2d8cf0",
                      cursor: "pointer",
                    },
                    on: {
                      click: () => {
                        this.$refs.salesOrderEdit.open(params.row, 0, true);
                      },
                    },
                  },
                  params.row.salesOrderNo,
              );
            },
          },
          {
            key: "totalAmount",
            width: 110,
            align: "center",
            render: (h, params) => {
              return h(
                  "span",
                  params.row.totalAmount === null ? "***" : params.row.totalAmount,
              );
            },
          },
          {
            key: "deliveryDate",
            width: 110,
            align: "center",
            render: (h, params) => {
              return h("span", params.row.deliveryDate ? params.row.deliveryDate.slice(0, 10) : "");
            },
          },
        ],
        options: [],
        disabled: false,
        selection: [],
        submitLoading: false,
      };
    },
    watch: {
      "filter.deliveryBeginDate": {
        handler(newVal) {
          if (newVal) {
            this.deliveryDateRange = [];
            this.deliveryDateRange.push(this.filter.deliveryBeginDate);
            this.deliveryDateRange.push(this.filter.deliveryEndDate);
          }
        },
      },
    },

    created() {
      this.getAreaOptions();
      this.getMaterialTypeList();
    },
    mounted() {
      // this.deliveryDateRange.push(this.$moment().format("yyyy-MM-DD"), this.$moment().add(6, "months").format("yyyy-MM-DD"));
      // this.filter.deliveryBeginDate = this.deliveryDateRange[0];
      // this.filter.deliveryEndDate = this.deliveryDateRange[1];
    },

    methods: {
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },

      selectHandle(selection) {
        this.selection = selection;
      },

      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },

      addEditHandle(row) {
        this.$refs.salesOrderEdit.open(row);
      },

      // 获取所属区域列表
      getAreaOptions() {
        this.$http.get("basic", "districts/selectAllDistrict").then((res) => {
          if (res.success) {
            this.options = res.data;
          }
        });
      },
      getMaterialTypeList() {
        this.$http.get("basic", "materialTypes/getAllList").then((res) => {
          if (res.success) {
            this.materialTypeList = res.data;
          }
        });
      },

      deliveryDateRangeChange(date) {
        if (date) {
          this.filter.deliveryBeginDate = date[0];
          this.filter.deliveryEndDate = date[1];
        } else {
          this.filter.deliveryBeginDate = "";
          this.filter.deliveryEndDate = "";
        }
      },

      createDelivery() {
        let customerId = this.selection[0].customerId;
        let result = this.selection.some((item) => item.customerId !== customerId);
        if (result) {
          this.$confirm("请选择相同客户的订单", "错误", {
            type: "error",
            showCancelButton: false,
          });
        } else {
          this.$refs.deliveryNoticeEdit.open(0, false, this.selection);
        }
      },

    },
  };
</script>
